const getDefaultPageSize = (): number =>
  parseInt(process.env.REACT_APP_DOCUMENT_PAGE_SIZE ?? '10', 10);
export default getDefaultPageSize;
